// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf, recordOf } from "@altostra/type-validations";
import { boolean, number, string, any } from "@altostra/type-validations/lib/primitives";

export const isEngagementQueryBuilderReportResult = objectOf({
  associated_dashboards: recordOf({
    key: string,
    value: objectOf({
      dashboard_id: string,
      dashboard_name: string,
      tiles: arrayOf(
        objectOf({
          tile_id: string,
          tile_name: string,
          tile_data_query_id: string,
        })
      ),
    }),
  }),
  edited_at: string,
  error_message: string,
  error_occurred: boolean,
  error_sql_state: string,
  failure_count: number,
  loading: boolean,
  name: string,
  query_params: objectOf({
    api_id: string,
    message_type: string,
  }),
  report_query: string,
  report_run_start_time: string,
  results: arrayOf(arrayOf(any)),
  results_generated: string,
  sql: string,
  _id: string,
});
